import * as React from 'react'
import { CreateInvoiceLine, IInvoiceLine } from '@getgreenline/homi-shared'
import { Popconfirm, Button, Table } from 'antd'
import { observer } from 'mobx-react'
import { BatchAddForm } from './BatchAddForm'
import { CreateInvoiceDetail } from '../InvoiceDetailStore'
import { ColumnProps } from 'antd/lib/table'

interface Props {
  product: CreateInvoiceLine | IInvoiceLine
  createInvoice: CreateInvoiceDetail
  renderColumns: <T>(columns: ColumnProps<T>[]) => ColumnProps<T>[]
}

interface BatchTableRecord {
  key: number
  batchNumber: string
  batchQtyReceived: number
  options?: JSX.Element
}

@observer
export class InvoiceDetailBatchTable extends React.Component<Props, {}> {
  private nestedTableColumns: ColumnProps<BatchTableRecord>[] = [
    {
      title: 'Lot #',
      dataIndex: 'batchNumber',
      key: 'batchNumber',
    },
    {
      title: 'Qty Received',
      dataIndex: 'batchQtyReceived',
      key: 'batchQtyReceived',
    },
    {
      title: '',
      dataIndex: 'options',
      key: 'options',
      width: 50,
      align: 'center',
    },
  ]

  removeBatch = (product: CreateInvoiceLine, index: number) => product.removeBatch(index)

  get dataSource(): BatchTableRecord[] {
    const { product } = this.props

    return product.batches.map((batch, index) => {
      return {
        key: index,
        batchNumber: batch.batchNumber,
        batchQtyReceived: batch.quantity,
        options:
          product instanceof CreateInvoiceLine ? (
            <Popconfirm
              title='Sure to remove this lot?'
              onConfirm={() => this.removeBatch(product, index)}
            >
              <Button icon='close' />
            </Popconfirm>
          ) : undefined,
      }
    })
  }

  render() {
    const { renderColumns, product, createInvoice } = this.props
    const { isEditMode, isEditable } = createInvoice
    return (
      <div>
        <Table
          className='w-50'
          size='small'
          columns={renderColumns<BatchTableRecord>(this.nestedTableColumns)}
          dataSource={this.dataSource}
          pagination={false}
          rowClassName={() => 'background-white'}
        />

        {isEditMode && isEditable && product instanceof CreateInvoiceLine && (
          <BatchAddForm className='mt-3' product={product} />
        )}
      </div>
    )
  }
}
